module.exports = __webpack_public_path__ + "h5/img/point_top.e867f6fd.png";